import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function KeyRedirect({ target }) {
  const { key } = useParams();
  const navigate = useNavigate();

  const redirect = () => {
    const state = { key: key };
    navigate(target, { state: state, replace: true });
  };

  useEffect(() => {
    if (key) redirect();
  }, [key]);

  return <></>;
}

export function useKeyLocation() {
  const location = useLocation();
  let key = "";
  if (location.state) {
    key = location.state.key;
  }
  return key;
}
